import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  :root {
    --bg: #f7f6f3;
    --surface: #ffffff;
    --ink: #0d0d0d;
    --muted: #888;
    --faint: #e8e6e1;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    height: 100%;
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
    overflow-y: scroll;
  }

  body {
    min-height: 100%;
    font-family: 'DM Sans', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: var(--bg);
    color: var(--ink);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  #root {
    min-height: 100%;
  }

  body.lightbox-open {
    overflow: hidden;
  }

  img {
    display: block;
    max-width: 100%;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    pointer-events: none;
  }

  a img {
    pointer-events: auto;
  }

  canvas {
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
  }

  a {
    color: inherit;
  }
`;

export default GlobalStyles;